<template>
    <div class="actions">
        <div class="action-title action-separator" />
        <LoadingDots v-if="isLoading" />
        <ActionLink v-if="!isLoading" icon="home" link="/home">Accueil</ActionLink>
        <ActionLink v-if="!isLoading" icon="question" link="/help">Aide</ActionLink>
        <ActionLink
            v-if="!isLoading && settings.mod_validation_enable === '1'"
            icon="check"
            link="/validation"
            >Validation</ActionLink
        >
        <ActionLink
            v-if="!isLoading && settings.mod_export_enable === '1'"
            icon="file-export"
            link="/export"
            >Export</ActionLink
        >
        <ActionLink
            v-if="!isLoading && (isRattacher || isAdmin) && settings.mod_rattachment_enable === '1'"
            icon="arrows-alt-h"
            link="/rattachment"
            >Rattachement classique</ActionLink
        >
        <ActionLink
            v-if="!isLoading && (isRattacher || isAdmin) && settings.mod_rattachment_enable === '1'"
            icon="arrows-alt-h"
            link="/rattachmentinverse"
            >Rattachement inverse</ActionLink
        >
        <ActionLink v-if="!isLoading && isAdmin" icon="cogs" link="/config"
            >Administration</ActionLink
        >
        <div v-if="!isLoading" class="action-title action-separator" />
        <LogoutLink v-if="!isLoading" class="action-title" />
    </div>
</template>

<script>
import LoadingDots from '@/components/LoadingDots';
import LogoutLink from '@/components/LogoutLink';
import ActionLink from '@/components/ActionLink';
import { authenticationService } from '@/services';
import { Role } from '@/helpers';

export default {
    data() {
        return {
            isLoading: true,
            settings: {
                mod_validation_enable: null,
                mod_export_enable: null,
                mod_rattachment_enable: null,
            },
            loaded_settings: [],
            user: authenticationService.currentUserValue,
        };
    },
    mounted() {
        this.loadSettings();
    },
    methods: {
        loadSettings() {
            this.$http
                .get('/api/setting/')
                .then(
                    (response) => {
                        const settings = response.body;
                        this.loaded_settings = settings;
                        settings.forEach((s) => (this.settings[s.name] = s.value));
                    },
                    (response) => {
                        // error callback
                        console.log(JSON.stringify(response));
                    },
                )
                .finally(() => (this.isLoading = false));
        },
    },
    components: {
        LogoutLink,
        ActionLink,
        LoadingDots,
    },
    computed: {
        isAdmin() {
            return this.user.role === Role.Admin;
        },
        isRattacher() {
            return this.user.role === Role.Rattacher;
        },
    },
};
</script>
